import React from "react";
import { useNavigate } from "react-router-dom";
import "./SelectProjectPage.css";

const SelectProjectPage = () => {
  const navigate = useNavigate();

  const handleSelect = (project) => {
    localStorage.setItem("active_project", project);
    if (project === "rasha") window.location.href="/admin/rasha";
    else if (project === "gazelle") window.location.href="/admin/gazelle";
  };

  return (
    <div className="project-selection-wrapper">
      <h2 className="title">Select a Project</h2>
      <div className="circle-container">
        <div className="circle-item" onClick={() => handleSelect("rasha")}>
          <div className="circle">RA</div>
          <span className="label">Rasha Abanni</span>
        </div>
        <div className="circle-item" onClick={() => handleSelect("gazelle")}>
          <div className="circle">GR</div>
          <span className="label">Gazelle by Rasha</span>
        </div>
      </div>
    </div>
  );
};

export default SelectProjectPage;
